import React from 'react';
import { Spin } from 'antd';
import useInsuranceBillingStatus from 'hooks/useInsuranceBillingStatus';
import useCurrentUser from 'hooks/useCurrentUser';
import { canShowGroupPracticeView } from 'utils/common';
import InsuranceBillingFees from '../InsuranceBillingFees';
import EligibilityCheckInvoices from '../EligibilityCheckInvoices';
import s from './s.module.less';

// Insurance billing 下的两种账单，按 persona 互斥（2026-09-16 拍板：enrolled 的 check 和
// advanced search 都免费，不再有 eligibility 发票）：
// - enrolled → 只有 Managed billing fee（报销回款的分成）；
// - 非 program → 只有 Eligibility checks（$0.25/次 + $1.50/advanced search；
//   他们真的没有 billing fee，空 tab 读起来像加载失败）。
// 白名单已移除（main cdff7ce8b），/status 对所有人开放，直接按 enrolled 分流。
//
// 视图跟随 Financials 一级 tab（与 Credentialing 同模式，member 在页面层已整体隐藏）：
// Practice View + group owner/admin → eligibility 走 practice 聚合（§1.6/1.7）；
// My Financials（solo / group owner）→ 个人发票。enrolled 的 group owner 在 My Financials
// 下没有任何账单（fee 归 Practice View）——该视图的 Insurance billing tab 由页面层整体隐藏
type Props = {
    isPractice?: boolean;
};

const InsuranceBillingTab: React.FC<Props> = ({ isPractice }) => {
    const [status, loading] = useInsuranceBillingStatus();
    const [currentUser] = useCurrentUser();

    if (loading) {
        return (
            <div className={s.loading}>
                <Spin />
            </div>
        );
    }

    // solo 的 Practice View 也是个人视图（practice = 自己），只有 group 的 owner/admin 走聚合
    const practiceView = !!isPractice && canShowGroupPracticeView(currentUser);

    // 与 InsuranceBillingPage 展示 claims dashboard 的判定一致
    const enrolled = status?.canBind ? !!status?.bound && status?.onboardingCompleted === true : !!status?.canView;

    if (enrolled) {
        return <InsuranceBillingFees />;
    }
    // group owner 的 My Financials：只看个人 eligibility 发票
    if (!isPractice && currentUser?.groupPractice) {
        return <EligibilityCheckInvoices />;
    }
    return <EligibilityCheckInvoices practiceView={practiceView} />;
};

export default InsuranceBillingTab;
